'use client'
import { Fragment, useContext, useEffect, useState } from 'react'
import { manrope } from "@/ui/fonts";
import MostarMarquee from "./MostarMarquee";
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  Popover,
  PopoverButton,
  PopoverGroup,
  PopoverPanel,
  Tab,
  TabGroup,
  TabList,
  TabPanel,
  TabPanels,
} from '@headlessui/react'
import { Bars3Icon, ChevronDownIcon, ShoppingBagIcon, XMarkIcon } from '@heroicons/react/24/outline'
import CartPopUp from '../Pop-up/CartPopUp';

const navigation = {
  categories: [
    {
      id: 'men',
      name: 'HOT SALE🔥',
      featured: [
        {
          name: 'Financiamiento',
          href: '/financiamiento',
          imageSrc: 'https://test.mincaelectric.com/wp-content/uploads/2024/07/menu-minca-02.jpg',
          imageAlt: 'Fianaciamiento',
        },
        {
          name: 'Tutoriales',
          href: '/tutoriales',
          imageSrc: 'https://test.mincaelectric.com/wp-content/uploads/2024/07/menu-minca-01.jpg',
          imageAlt:
            'Tutoriales',
        },
      ],
      sections: [
        {
          id: 'clothing',
          name: 'Patinetas Eléctricas',
          href: "/productos/Patinetas_Electricas",
          items: [
            { name: 'Minca 350W Lite', href: '/especificaciones/Especificaciones_Scooter_Electrico_Minca_350W_Lite' },
            { name: 'Minca 500W', href: '/especificaciones/Especificaciones_Scooter_Electrico_Minca_500W' },
            { name: 'Minca 800W', href: '/especificaciones/Especificaciones_Scooter_Electrico_Minca_800W' },
            { name: 'Minca 1600W', href: '/especificaciones/Especificaciones_Scooter_Electrico_Minca_1600W' },
            { name: 'Minca 2400W', href: '/especificaciones/Especificaciones_Scooter_Electrico_Minca_2400W' },
          ],
        },
        {
          id: 'brands',
          name: 'Mopeds Eléctricas',
          href: "/productos/Mopeds_Electricas",
          items: [
            { name: 'Minca City 350W', href: '/especificaciones/Moped_Electrica_Minca_City_350w' },
          ],
        },
        {
          id: 'accessories',
          name: 'Accesorios Minca',
          href: "/productos/Accesorios_Minca",
          items: [
            { name: 'Casco Full Face Minca', href: '/productos/Accesorios_Minca/Casco_Full_Face_Minca' },
            { name: 'Casco Integral Minca', href: '/productos/Accesorios_Minca/Casco_Integral_Minca' },
            { name: 'Gafas Minca', href: '/productos/Accesorios_Minca/Gafas_Minca' },
            { name: 'Baúl Minca City', href: '/productos/Accesorios_Minca/Bal_Minca_City' },
            { name: 'Pijama Minca City', href: '/productos/Accesorios_Minca/Pijama_Minca_City' },
            { name: 'Baúl Minca', href: '/productos/Accesorios_Minca/Bal_Minca' },
            { name: 'Poncho Minca', href: '/productos/Accesorios_Minca/Poncho_Minca' },
          ],
        },
      ],
    },
  ],
  pages: [
    { name: 'Servicio técnico', href: '/servicios' },
    { name: 'Showrooms', href: '/showrooms' },
    { name: 'Recursos', href: '/recursos' },
    { name: 'Tendencias', href: '/tendencias' },
  ],
}


export const Header = () => {
  const [open, setOpen] = useState(false)
  //const [cart, setCart] = useState({ totalQty: 0 });
  const [scrolled, setScrolled] = useState(false);
  const [dropdownVisible, setDropdownVisible] = useState(false);

  const toggleDropdown = () => {
    setDropdownVisible(!dropdownVisible);
  };

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 100);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  /* useEffect(() => {
    const fetchCart = async () => {
      const session_id = localStorage.getItem("session_id");
      if (!session_id) return;

      try {
        const response = await fetch(`/api/get_products_for_cart?session_id=${session_id}`);
        if (response.ok) {
          const data = await response.json();
          // Sum the quantities
          const totalQuantity = data.products.reduce((sum, item) => sum + item.quantity, 0);

          // Update state
          setCart({ totalQty: totalQuantity });


          // Dispatch custom event
          const cartUpdateEvent = new CustomEvent("cartUpdated", { detail: { totalQty: totalQuantity } });
          window.dispatchEvent(cartUpdateEvent);
        } else {
          console.error("Failed to fetch cart");
        }
      } catch (error) {
        console.error("Error fetching cart data:", error);
      }
    };

    const refreshCartListener = () => fetchCart();

    window.addEventListener("refreshCart", refreshCartListener);

    fetchCart(); // Initial fetch

    return () => window.removeEventListener("refreshCart", refreshCartListener);
  }, []); */

  return (
    <div className={`transition-colors duration-300 ${scrolled ? 'bg-black' : 'bg-white'} z-50 fixed top-0 w-screen`}>
      <MostarMarquee />
      {/* Mobile menu */}
      <Dialog open={open} onClose={setOpen} className="relative z-40 lg:hidden">
        <DialogBackdrop
          transition
          className="fixed inset-0 bg-black bg-opacity-25 transition-opacity duration-300 ease-linear data-[closed]:opacity-0"
        />

        <div className="fixed inset-0 z-40 flex">
          <DialogPanel
            transition
            className="relative flex w-full max-w-xs transform flex-col overflow-y-auto bg-white pb-12 shadow-xl transition duration-300 ease-in-out data-[closed]:-translate-x-full"
          >
            <div className="flex px-4 pb-2 pt-5">
              <button
                type="button"
                onClick={() => setOpen(false)}
                className={`relative -m-2 inline-flex items-center justify-center rounded-md p-2 ${scrolled ? 'text-white' : 'text-gray-700'}`}
              >
                <span className="absolute -inset-0.5" />
                <span className="sr-only">Close menu</span>
                <XMarkIcon aria-hidden="true" className="h-6 w-6" />
              </button>
            </div>

            {/* Links */}
            <TabGroup className="mt-2">
              <TabPanels as={Fragment}>
                {navigation.categories.map((category) => (
                  <TabPanel key={category.name} className="space-y-10 px-4 pb-8 pt-10">
                    <a href="/productos" className={`${manrope.className} font-bold text-gray-900 text-[20px] mb-4`}>HOT SALE🔥</a><br />
                    {/* <span className={`${manrope.className} font-bold text-gray-900 text-[20px] mb-4`}>Productos</span> */}
                    {category.sections.map((section) => (
                      <div key={section.name}>
                        <a href={section.href} id={`${category.id}-${section.id}-heading-mobile`} className={`${manrope.className} font-bold text-gray-900`}>
                          {section.name}
                        </a>
                        {/* <span className={`${manrope.className} font-bold text-gray-900`}>{section.name}</span> */}
                        <ul
                          role="list"
                          aria-labelledby={`${category.id}-${section.id}-heading-mobile`}
                          className="mt-6 flex flex-col space-y-6"
                        >
                          {section.items.map((item) => (
                            <li key={item.name} className="flow-root">
                              <a href={item.href} className={`${manrope.className} -m-2 block p-2 text-gray-500 text-[14px]`}>
                                {item.name}
                              </a>
                            </li>
                          ))}
                          {section.id === "accessories" &&
                            <li className="flex">
                              <a href="/productos/Accesorios_Minca" className={`${manrope.className} text-black hover:text-gray-800 hover:underline text-[14px] font-semibold underline`}>
                                Ver Accesorios
                              </a>
                            </li>
                          }
                        </ul>
                      </div>
                    ))}
                    <div className="grid grid-cols-2 gap-x-4">
                      {category.featured.map((item) => (
                        <div key={item.name} className="group relative text-sm">
                          <div className="aspect-h-1 aspect-w-1 overflow-hidden rounded-lg bg-gray-100 group-hover:opacity-75">
                            <img alt={item.imageAlt} src={item.imageSrc} className="object-cover object-center" />
                          </div>
                          <a href={item.href} className="mt-6 block font-medium text-gray-900">
                            <span aria-hidden="true" className={`${manrope.className} absolute inset-0 z-10`} />
                            {item.name}
                          </a>
                          <p aria-hidden="true" className="mt-1">
                            Conoce más
                          </p>
                        </div>
                      ))}
                    </div>
                  </TabPanel>
                ))}
              </TabPanels>
            </TabGroup>

            <div className="space-y-6 border-t border-gray-200 px-4 py-6">
              {navigation.pages.map((page) => (
                <div key={page.name} className="flow-root">
                  <a href={page.href} className={`${manrope.className} -m-2 block p-2 font-bold text-gray-900`}>
                    {page.name}
                  </a>
                </div>
              ))}
            </div>

            <div className="space-y-6 border-t border-gray-200 px-4 py-6">
              <div className="flow-root">
                <a href="/contacto" className={`${manrope.className} -m-2 block p-2 font-bold text-gray-900`}>
                  Contacto
                </a>
              </div>
              <div className="flow-root">
                <a href="testdrive" className={`${manrope.className} -m-2 block p-2 font-bold text-gray-900`}>
                  Agendar Test Drive
                </a>
              </div>
            </div>

            <div className="hidden border-t border-gray-200 px-4 py-6">
              <a href="/" className="-m-2 flex items-center p-2">
              <svg
                  xmlns="https://www.w3.org/2000/svg"
                  width={25}
                  height={25}
                  aria-hidden="true"
                  className="iconify iconify--twemoji"
                  viewBox="0 0 36 36"
                >
                  <path fill="#006847" d="M4 5a4 4 0 0 0-4 4v18a4 4 0 0 0 4 4h7V5H4z" />
                  <path fill="#CE1126" d="M32 5h-7v26h7a4 4 0 0 0 4-4V9a4 4 0 0 0-4-4z" />
                  <path fill="#EEE" d="M11 5h14v26H11z" />
                  <path fill="#A6D388" d="M23 18a5 5 0 1 1-10 0h-1a6 6 0 0 0 12 0h-1z" />
                  <path
                    fill="#5C913B"
                    d="M13.543 20.269a.498.498 0 0 0-.673-.218.5.5 0 0 0-.219.673c.09.177.189.35.296.516v.001l.004.006v.001l.008.011v.001l.003.006.001.002.004.005v.001l.003.005v.002l.003.005.001.002.003.005.001.002.003.004.002.003.002.003.001.003.003.005.001.001.002.003.003.006.001.002.003.005.001.002.007.01v.001l.005.007v.001c.052.077.105.151.161.226a.497.497 0 0 0 .697.101.499.499 0 0 0 .103-.699 5.96 5.96 0 0 1-.43-.71zm-.497-1.582a5.282 5.282 0 0 1-.046-.833.5.5 0 0 0-.485-.514l-.036.001a.5.5 0 0 0-.478.485 8.061 8.061 0 0 0-.001.311v.09l.001.005v.028l.001.003-.001.002v.003l.001.002v.029l.001.003v.011l.001.019.001.009v.011c.009.16.025.319.046.477a.5.5 0 0 0 .562.425.503.503 0 0 0 .433-.567zm5.294 4.3-.006.001-.124.008a5.087 5.087 0 0 1-.71-.021.5.5 0 0 0-.1.995l.125.011.004.001.002-.001.003.001h.002l.006.001h.006l.003.001h.001l.006-.001.003.001h.005l.006.001.005.001h.013l.006.001h.013c.152.01.305.015.459.012h.039l.007-.001.006.001h.015l.005-.001h.019l.006-.001h.001l.005.001.001-.001.006.001h.001l.005-.001h.008l.006-.001h.006l.001.001.006-.001h.007l.005-.001h.02l.005-.001h.004l.004-.001.004.001h.005l.004-.001h.005c.042-.001.085-.005.127-.007a.494.494 0 0 0 .453-.526.493.493 0 0 0-.514-.473zm-2.439-.448a5.07 5.07 0 0 1-.724-.411.495.495 0 0 0-.303-.087.5.5 0 0 0-.263.911l.001.001.006.003.006.006.006.004.006.005c.266.181.548.34.842.476a.498.498 0 0 0 .663-.243.498.498 0 0 0-.24-.665zm5.03-.398a.498.498 0 0 0-.248.08 5.142 5.142 0 0 1-.734.387.498.498 0 0 0 .213.96.528.528 0 0 0 .173-.038l.134-.06h.002l.006-.004.002-.001.004-.002h.004l.004-.002.002-.002.006-.001.002-.002.003-.002.005-.002.003-.001.005-.002.002-.001.005-.002.002-.001c.003-.002.003-.003.005-.003l.002-.001.006-.003h.002l.006-.003.006-.003.002-.001.005-.003.002-.001.006-.003.001-.001.007-.001.007-.004.002-.001.004-.003h.002l.006-.004.008-.002.006-.004h.001l.007-.004.001-.001.014-.006.007-.003.014-.008.008-.003.006-.003h.001l.014-.008v-.001l.006-.002h.001l.022-.012.007-.002.014-.008.007-.004h.001c.001-.001.003-.002.007-.002.002-.003.004-.004.006-.005l.008-.004.006-.003v-.001l.014-.006h.001l.007-.004.001-.001.005-.003h.001l.007-.004.006-.003h.002l.006-.004v-.001l.007-.003.001-.001.006-.003v-.001l.006-.002.002-.001.004-.003.003-.001.005-.003.002-.001.005-.003.002-.001.006-.002c-.001-.001 0-.001.001-.001l.006-.003.002-.001.004-.003.002-.001.006-.003.002-.001c0-.002.002-.002.004-.003l.003-.001.004-.002.003-.002.004-.002.003-.002.003-.002.003-.003.005-.001.004-.001.002-.002.004-.002.004-.003.002-.001.004-.002.004-.003.003-.002c.002.001.003 0 .005-.001l.002-.002.004-.002.003-.002.003-.002.004-.002.004-.003.002-.001c.002-.001.006-.001.008-.003-.002-.001-.002-.001 0-.001l.004-.002.007-.005.002-.001.007-.003v-.001l.012-.006.008-.005a.095.095 0 0 1 .02-.011h.001c.063-.038.128-.077.19-.117a.5.5 0 0 0 .152-.69.554.554 0 0 0-.457-.225zm2.571-4.618-.024.001a.5.5 0 0 0-.479.498c0 .277-.025.557-.072.829a.5.5 0 0 0 .987.168v-.005l.001-.002.001-.002-.001-.002.001-.002v-.002l.001-.002v-.003l.001-.002v-.009c.002-.001.002-.003.002-.004v-.006a6.23 6.23 0 0 0 .052-.391l-.001-.001.001-.003v-.001l.001-.004v-.011l.002-.003v-.001l-.001-.003v-.002l.001-.003v-.004l.002-.001-.002-.003v-.004c.002-.001.002-.002.002-.003v-.019l.002-.003v-.001a6.22 6.22 0 0 0 .021-.495.5.5 0 0 0-.498-.499zm-.443 2.696a.5.5 0 0 0-.68.196 4.853 4.853 0 0 1-.463.692.5.5 0 0 0 .783.622c.116-.146.227-.299.33-.455.002-.007.007-.014.011-.02l.001-.001.004-.006v-.001l.004-.007c.002-.002.004-.004.004-.006l.001.001.004-.006v-.001a.01.01 0 0 0 .003-.007l.002-.001.004-.006v-.001c.002-.001.002-.003.003-.005l.001-.001.004-.006.001-.002.002-.005.003-.002.002-.005h.002l.002-.006.001-.002.004-.004.001-.002c.001-.002.001-.004.003-.005l.001-.003.004-.003c0-.001 0-.002.002-.003v-.004l.003-.002.003-.005.001-.002.003-.006.002-.002.002-.004.002-.003c0-.001 0-.002.002-.003 0-.001 0-.002.002-.003l.003-.005.001-.003.002-.003.002-.003c.002-.001.002-.002.002-.003.002-.001.002-.002.002-.004l.002-.003.003-.004.003-.004v-.003l.002-.003.003-.004.003-.003v-.003l.004-.005v-.003c.002-.001.003-.002.003-.004l.002-.002.002-.003.003-.005.002-.003v-.002l.004-.005c0-.001 0-.002.002-.003l.001-.003.003-.004.002-.004.002-.003c.001-.001 0-.003.002-.004 0-.001 0-.002.002-.002l.002-.005.002-.002.002-.006.002-.001.002-.004.002-.002.002-.005.002-.002.002-.006c.002-.001 0-.002 0-.002l.004-.005.001-.002.004-.005v-.001l.003-.006.002-.002.002-.006v-.001l.005-.005.003-.006v-.001l.004-.007.002-.001.025-.047a.498.498 0 0 0-.199-.672z"
                  />
                  <ellipse cx={18} cy={21} fill="#55ACEE" rx={3} ry={1} />
                  <ellipse cx={18.5} cy={21} fill="#FFCC4D" rx={1.5} ry={1} />
                  <path
                    fill="#5C913B"
                    d="M19.117 21.274a.503.503 0 0 1-.44-.739c.16-.294.328-.561.502-.795a10 10 0 0 1-.43.009c-.276 0-.528-.225-.528-.501s.195-.5.472-.5l.082.001c.296 0 .6-.018.872-.043a.49.49 0 0 1 .41.156c.014-.011.028-.022.043-.031.1-.066.193-.119.28-.161a.49.49 0 0 1 .211-.094l.036-.007c.188-.061.32-.069.373-.069a.498.498 0 0 1 .477.647c-.082.266-.265.326-.586.39a1.2 1.2 0 0 0-.238.128.507.507 0 0 1-.599-.034.499.499 0 0 1-.002.614c-.17.217-.337.475-.496.768a.498.498 0 0 1-.439.261zm-1.42-1.589a.497.497 0 0 1-.066-.004 6.98 6.98 0 0 1-1.056-.221.5.5 0 0 1-.337-.622l.006-.02-.012.023a.5.5 0 0 1-.681.192 4.126 4.126 0 0 1-.907-.681.5.5 0 0 1 .707-.707c.197.197.428.37.688.515a.5.5 0 0 1 .229.597.5.5 0 0 1 .59-.256c.276.082.579.145.9.188a.5.5 0 0 1-.061.996zm-2.452-2.339c-.426 0-.977-.165-1.311-.559-.512-.604-.813-1.379-.767-1.973.012-.159-.143-.287-.295-.327-.087-.023-.24-.037-.312.118a.25.25 0 0 1-.454-.21c.156-.339.506-.49.892-.392.358.093.701.415.667.85-.036.462.226 1.109.65 1.61.223.264.611.371.875.381.215.011.324-.038.347-.059-.056-.133-.797-.523-1.113-.689-.269-.141-.349-.335-.369-.472-.067-.455.4-.916.852-1.36.159-.157.31-.305.392-.414.093-.123.078-.205.06-.256-.069-.187-.368-.372-.728-.452-.333-.074-.558-.235-.668-.479-.145-.321-.068-.741.234-1.285a.25.25 0 1 1 .437.243c-.285.512-.257.744-.215.837.042.092.149.157.32.195.423.094.932.345 1.088.767.089.241.044.501-.128.73-.104.139-.268.3-.441.471-.258.254-.739.727-.708.931.006.042.061.079.107.102.751.394 1.25.679 1.352 1.028a.456.456 0 0 1-.042.359c-.097.169-.299.273-.585.299-.043.004-.09.006-.137.006z"
                  />
                  <ellipse cx={19.5} cy={18} fill="#FFCC4D" rx={0.5} ry={1} />
                  <path
                    fill="#FFCC4D"
                    d="M17.292 17.188c0 .288-.345.521-.771.521-.425 0-.771-.233-.771-.521s.345-.521.771-.521c.425 0 .771.233.771.521zm-1.187-4.627c.05.212-.227.46-.619.553-.392.093-.75-.004-.801-.216-.05-.213.227-.461.618-.554.393-.092.752.004.802.217z"
                  />
                  <path
                    fill="#C1694F"
                    d="M22.533 17.955c.09.07.243-.729.22-.978 0-.017-.029-.546.083-.924.069-.128.073-1.083-.033-1.334.084-.007.185-.034.197-.136-.388.143-.479-.817-.852-1.369-.362-.553-.811-.875-1.28-1.211a.979.979 0 0 1 .162-.27c-.575.288-1.471-.755-2.795-.677-.297.029-.438.047-.514.229-.247.02-.498.076-.498.401 0 .078.071.22.229.221.216.063.392.014.539.316l.039.312s-.193-.247-.299-.286l.065-.133c-.1-.058-.277-.011-.277-.011s-.385-.18-.694-.132l-.06-.25c-.054.154-.175.146-.192.291-.034-.104-.079-.233-.111-.337-.109.148-.077.308-.116.462-.042.036-.128.037-.15-.062-.011-.122-.026-.133-.026-.278-.078.137-.172.204-.203.439l-.083-.26c.003.307-.261.49-.511.707-.071.13.011.131.017.198l.132.066.237-.017c.039.049.007.053.11.084.276.077.62-.254.89.267-.124.104-.249.347-.209.393.05 0-.1.07.102.006-.21.204-.352.473-.352.489-.024.058.084-.008.062.097l.05-.006c-.479.518-.016 1.075-.067 1.374.08.129.09-.003.19-.016.084.368.326.591.474.882l-.312.003c.007.138.132.269.231.39l-.209.066a1.128 1.128 0 0 0-.352.274c-.069.168.333.208.527.238l-.007.203c.303.029.653-.061.653-.078l.076-.059.171.094c.057 0 .146-.228.105-.403.11.131.214.342.324.474l.103-.014c.094.149.223.297.317.446l.105.04c.061-.021.113-.028.146-.148l.048.084.166-.114.116-.023.087.142c.051-.019.101-.13.104-.248.052.103.066.095.104.122l.077-.162.415.388.314.018c.112.076.419.124.471.001.252.108.549-.014.534-.134.232.092.589.03.589.015.043-.005.153-.113.049-.194-.767-.534-1.904-1.418-2.343-1.631 0-.158-.119-.727-.247-.883l.104-.174c.299.279.407.252.566.296.17.135.229.34.399.527l.152.028a2.583 2.583 0 0 0-.554-.873c.164.082.436.301.618.46.12.201.155.361.265.613.08.051.162.238.151.083-.019-.291-.224-.752-.224-.785.326.258.322.66.421.905.083.124.125.29.161.251l-.096-.756-.056-.277c.241.139.327.669.44 1.305 0 .101.041.212.035.277.052.064.111.241.11.136 0 0 0-1.034-.071-1.271-.018-.127.03-.333.03-.333.088.429.182.894.271 1.322v.315l.132.133c.025-.26.055-.518.081-.776l-.099-.925v-.264c-.002-.093.085-.076.14.03.013.227.013.404.022.63.039.258.066.447.085.776.011.266.023.904.079.893z"
                  />
                </svg>
                <span className="sr-only">, change currency</span>
              </a>
            </div>
          </DialogPanel>
        </div>
      </Dialog>

      <header className={`relative ${scrolled ? 'bg-black text-white' : 'bg-white text-gray-900'}`}>
        <nav aria-label="Top" className="lg:mx-16  px-4 sm:px-6 lg:px-8">
          <div>
            <div className={`flex h-16 items-center border-b ${scrolled ? 'border-gray-700' : 'border-gray-200'} 2xl:w-full`}>
              <button
                type="button"
                onClick={() => setOpen(true)}
                className={`relative rounded-md p-2 lg:hidden ${scrolled ? 'text-white' : 'text-gray-700'}'}`}
              >
                <span className="absolute -inset-0.5" />
                <span className="sr-only">Open menu</span>
                <Bars3Icon aria-hidden="true" className={`${manrope.className} h-6 w-6 ${scrolled ? 'text-white' : 'text-gray-400'}`} />
              </button>

              {/* Logo */}
              <div className="ml-4 flex lg:ml-0">
                <a href="/">
                  <span className="sr-only">Your Company</span>
                  <img
                    alt=""
                    src="/logo.png"
                    className={`h-8 w-auto ${scrolled ? 'invert' : ''}`}
                  />
                </a>
              </div>

              {/* Flyout menus */}
              <PopoverGroup className="hidden lg:ml-8 lg:block lg:self-stretch">
                <div className="flex h-full space-x-8">
                  {navigation.categories.map((category) => (
                    <Popover key={category.name} className="flex">
                      {/* <a href="/productos" className={`${manrope.className} flex items-center text-sm font-medium transition-colors duration-200 ease-out ${scrolled ? 'text-white hover:text-gray-400' : 'text-gray-700'}`}> */}
                      <a href="/productos" className={`${manrope.className} flex items-center text-sm font-medium transition-colors duration-200 ease-out text-red-500 hover:text-red-700`}>
                        {category.name}
                      </a>
                      <div className="relative flex">
                        <PopoverButton className={`${manrope.className} relative z-10 -mb-px flex items-center pt-px text-sm font-medium transition-colors duration-200 ease-out focus:outline-none focus:ring-0 ${scrolled ? 'text-white hover:text-gray-400 data-[open]:text-white' : 'text-gray-700 hover:text-gray-800 data-[open]:text-gray-900'}`}>
                          {/* <span className={`${manrope.className} flex items-center text-sm font-medium transition-colors duration-200 ease-out ${scrolled ? 'text-white hover:text-gray-400' : 'text-gray-700'}`}>{category.name}</span> */}
                          <ChevronDownIcon
                            strokeWidth={2.5}
                            className={`h-3 w-3 transition-transform  ml-2`}
                          />
                        </PopoverButton>
                      </div>

                      <PopoverPanel
                        transition
                        className={`absolute inset-x-0 top-full text-sm transition data-[closed]:opacity-0 data-[enter]:duration-200 data-[leave]:duration-150 data-[enter]:ease-out data-[leave]:ease-in bg-white text-gray-500`}
                      >
                        {/* Presentational element used to render the bottom shadow, if we put the shadow on the actual panel it pokes out the top, so we use this shorter element to hide the top of the shadow */}
                        <div aria-hidden="true" className="absolute inset-0 top-1/2 bg-white shadow" />

                        <div className="relative">
                          <div className="mx-auto max-w-7xl px-8">
                            <div className="grid grid-cols-2 gap-x-8 gap-y-10 py-16 2xl:w-[1720px] 2xl:-ml-[275px]">
                              <div className="col-start-2 grid grid-cols-2 gap-x-8">
                                {category.featured.map((item) => (
                                  <div key={item.name} className="group relative text-base sm:text-sm">
                                    <div className="aspect-h-1 aspect-w-1 overflow-hidden rounded-lg bg-gray-100 group-hover:opacity-75">
                                      <img
                                        alt={item.imageAlt}
                                        src={item.imageSrc}
                                        className="object-cover object-center"
                                      />
                                    </div>
                                    <a href={item.href} className="mt-6 block font-medium 2xl:text-[16px] text-gray-900">
                                      <span aria-hidden="true" className={`${manrope.className} absolute inset-0 z-10`} />
                                      {item.name}
                                    </a>
                                    <p aria-hidden="true" className="mt-1 2xl:text-[16px]">
                                      Conoce más
                                    </p>
                                  </div>
                                ))}
                              </div>
                              <div className="row-start-1 grid grid-cols-3 gap-x-4 gap-y-10 text-sm">
                                {category.sections.map((section) => (
                                  <div key={section.name} className='ml-6'>
                                    <a href={section.href} id={`${section.name}-heading`} className={`${manrope.className} font-bold 2xl:text-[16px] text-gray-900`}>
                                      {section.name}
                                    </a>
                                    {/* <span className={`${manrope.className} font-bold 2xl:text-[16px] text-gray-900`}>{section.name}</span> */}
                                    <ul
                                      role="list"
                                      aria-labelledby={`${section.name}-heading`}
                                      className="mt-6 space-y-6 sm:mt-4 sm:space-y-4 2xl:space-y-8"
                                    >
                                      {section.items.map((item) => (
                                        <li key={item.name} className="flex">
                                          <a href={item.href} className={`${manrope.className} hover:text-gray-800 hover:underline text-[14px]`}>
                                            {item.name}
                                          </a>
                                        </li>
                                      ))}
                                      {section.id === "accessories" &&
                                        <li className="flex">
                                          <a href="/productos/Accesorios_Minca" className={`${manrope.className} text-black hover:text-gray-800 hover:underline text-[14px] font-semibold underline`}>
                                            Ver Accesorios
                                          </a>
                                        </li>
                                      }
                                    </ul>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>
                        </div>
                      </PopoverPanel>
                    </Popover>
                  ))}

                  {navigation.pages.map((page) => (
                    <a
                      key={page.name}
                      href={page.href}
                      className={`${manrope.className} flex items-center text-sm font-medium transition-colors duration-200 ease-out ${scrolled ? 'text-white hover:text-gray-400' : 'text-gray-700'}`}
                    >
                      {page.name}
                    </a>
                  ))}
                </div>
              </PopoverGroup>

              <div className="ml-auto flex items-center">
                <div className="hidden lg:flex lg:flex-1 lg:items-center lg:justify-end lg:space-x-6">
                  <a href="/contacto" className={`${manrope.className} text-sm font-medium transition-colors duration-200 ease-out ${scrolled ? 'text-white hover:text-gray-400' : 'text-gray-700'}`}>
                    Contacto
                  </a>
                  <span aria-hidden="true" className="h-6 w-px bg-gray-200" />
                  <a href="/testdrive" className={`${manrope.className} text-sm font-medium transition-colors duration-200 ease-out ${scrolled ? 'text-white hover:text-gray-400' : 'text-gray-700'}`}>
                    Agendar Test Drive
                  </a>
                </div>

                <div className="lg:ml-8 mb-2 lg:flex">
                  <TabGroup className="mt-2">
                    <div>
                      <TabList className="-mb-px flex space-x-8 pl-4">
                        {/* Actual country */}
                        <div className="relative">
                          <div className='flex items-center' onClick={toggleDropdown}>
                            <svg
                              xmlns="https://www.w3.org/2000/svg"
                              width={25}
                              height={25}
                              aria-hidden="true"
                              className="iconify iconify--twemoji"
                              viewBox="0 0 36 36"
                            >
                              <path fill="#FBD116" d="M32 5H4a4 4 0 0 0-4 4v9h36V9a4 4 0 0 0-4-4z" />
                              <path fill="#22408C" d="M0 18h36v7H0z" />
                              <path fill="#CE2028" d="M0 27a4 4 0 0 0 4 4h28a4 4 0 0 0 4-4v-2H0v2z" />
                            </svg>
                            <ChevronDownIcon
                              strokeWidth={2.5}
                              className={`hidden h-3 w-3 transition-transform lg:block ml-2`}
                              />
                          </div>

                          {/* Dropdown for the other country */}
                          {dropdownVisible && (
                            <div className="absolute top-8 -left-2 mt-2 w-10 bg-white shadow-lg border border-gray-200 rounded-lg z-10">
                              <a href="https://www.mincaelectric.mx/"
                                className={`flex items-center p-2 text-gray-700 hover:text-gray-800 ${scrolled ? 'text-white' : ''}`}
                              >
                                <svg
                                  xmlns="https://www.w3.org/2000/svg"
                                  width={25}
                                  height={25}
                                  aria-hidden="true"
                                  className="iconify iconify--twemoji cursor-pointer"
                                  viewBox="0 0 36 36"
                                >
                                  <path fill="#006847" d="M4 5a4 4 0 0 0-4 4v18a4 4 0 0 0 4 4h7V5H4z" />
                                  <path fill="#CE1126" d="M32 5h-7v26h7a4 4 0 0 0 4-4V9a4 4 0 0 0-4-4z" />
                                  <path fill="#EEE" d="M11 5h14v26H11z" />
                                  <path fill="#A6D388" d="M23 18a5 5 0 1 1-10 0h-1a6 6 0 0 0 12 0h-1z" />
                                  <ellipse cx={18} cy={21} fill="#55ACEE" rx={3} ry={1} />
                                  <ellipse cx={18.5} cy={21} fill="#FFCC4D" rx={1.5} ry={1} />
                                </svg>
                              </a>
                            </div>
                          )}
                        </div>
                      </TabList>
                    </div>
                  </TabGroup>
                </div>

                {/* Cart */}
                <CartPopUp scrolled={scrolled} />
                {/* <div className="ml-4 flow-root lg:ml-6">
                  <a href="/cart" className={`group -m-2 flex items-center p-2 ${scrolled ? 'text-white' : ''}`}>
                    <svg
                      xmlns="https://www.w3.org/2000/svg"
                      width={30}
                      height={30}
                      fill="none"
                      stroke="#000"
                      viewBox="0 0 24 24"
                    >
                      <g stroke="#9CA3AF" strokeWidth={1.5}>
                        <path
                          strokeLinecap="round"
                          d="m2 3 .265.088c1.32.44 1.98.66 2.357 1.184C5 4.796 5 5.492 5 6.883V9.5c0 2.828 0 4.243.879 5.121.878.879 2.293.879 5.121.879h8"
                        />
                        <path d="M7.5 18a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM16.5 18a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM5 6h11.45c2.055 0 3.083 0 3.527.674.445.675.04 1.619-.77 3.508l-.428 1c-.378.882-.567 1.322-.942 1.57-.376.248-.856.248-1.815.248H5" />
                      </g>
                    </svg>
                    {cart?.totalQty > 0 ? (
                      <span className={`${manrope.className} text-sm font-medium z-auto rounded-[50%] bg-red-500 w-5 h-5 pl-1.5 mb-4 -ml-3 text-[7px] text-white`}>{cart?.totalQty}</span>
                    ) : ("")}
                    <span className="sr-only">items in cart, view bag</span>
                  </a>
                </div> */}
              </div>
            </div>
          </div>
        </nav>
      </header>
    </div>
  )
}
